










import { Vue, Component, Prop } from 'vue-property-decorator';
import VueApexCharts from 'vue-apexcharts/dist/vue-apexcharts';
import HelpPopupComponent from "@/app/presenter/components/help-popup-component.vue";

@Component({
    components: {
        VueApexCharts,
        HelpPopupComponent
    }
})
export default class UiChartComponent extends Vue {
    @Prop()
    public series: object;

    @Prop()
    public titles: string[] = [];

    public titlesArray = this.titles.map((str) => str.split(' '));

    private options: object = {
        chart: {
            stacked: true,
            toolbar: {
                show: false
            },
            zoom: {
                enabled: true
            },
            type: 'bar'
        },
        plotOptions: {
            bar: {
                columnWidth: '20%',
                endingShape: 'flat',
                horizontal: false,
                colors: {
                    backgroundBarColors: ['#F2F6FA'],
                    backgroundBarOpacity: 1
                }
            }
        },
        responsive: [{
            breakpoint: 480,
            options: {
                legend: {
                    position: 'bottom',
                    offsetX: -10,
                    offsetY: 0
                }
            }
        }],
        xaxis: {
            type: 'text',
            categories: this.titlesArray,
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            }
        },
        yaxis: {
            max: 100,
            labels: {
                formatter: (val: string) => `${val}%`
            }
        },
        grid: {
            borderColor: '#F2F6FA'
        },
        fill: {
            colors: ['#52AE30', '#006648'],
            opacity: 1
        },
        legend: {
            horizontalAlign: 'left',
            position: 'top',
            markers: {
                width: 28,
                height: 6,
                strokeWidth: 0,
                strokeColor: '#fff',
                radius: 12,
                offsetX: 0,
                offsetY: 0,
                fillColors: ['#52AE30', '#006648']
            }
        },
        dataLabels: {
            enabled: false
        },
        states: {
            hover: {
                filter: {
                    type: 'none'
                }
            },
            active: {
                filter: {
                    type: 'none'
                }
            }
        },
        tooltip: {
            marker: {
                fillColors: ['#52AE30', '#006648']
            }
        }
    };
}
